var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-list"},_vm._l((_vm.listNew),function(item,index){return _c('el-image',{key:index,attrs:{"src":item,"fit":"contain ","preview-src-list":_vm.listNew}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }